export const VIGNETTE_COLOR = '#c4c4c4'
export const ALLOWED_FACES_AMOUNT = 2
export const MIN_FACE_DETECTION_CONFIDENCE = 0.8

export const DEFAULT_BLUR_RADIUS = 45

export const VIGNETTE_TYPE_OPAQUE = 'OPAQUE'
export const VIGNETTE_TYPE_BLUR_2 = 'BLUR_2.0'
